import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=ca4eceee&scoped=true"
import script from "./supplierList.vue?vue&type=script&lang=js"
export * from "./supplierList.vue?vue&type=script&lang=js"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=ca4eceee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4eceee",
  null
  
)

export default component.exports